export default __webpack_public_path__ + "2c695fb0e2d0c45c9a6fb69510335e5f.png";